import React from 'react';
import Button from './Button';

export default function PrimaryButton(props) {
  return <Button {...props} isPrimary />;
}
